import { useState } from 'react'
import { Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import { actions } from '../../PendingReceivementsState'
import { toast } from 'react-toastify'
import { capitalizeString } from 'src/utils/capitalize'
import ConfirmOrRejectModal from 'src/features/base/components/ConfirmOrRejectModal'
import theme from 'src/styles/theme'
import * as S from './CardUnreceivedProduct.styles'

interface CardUnreceivedProductProps {
  receivementId: string
  idArItem: number
  currentIdModel: number
  newIdModel: number
  invoiceNumber: number
  invoiceProductName: string
  invoiceUnitType: string
  stockProductName: string
  productCode: string
  originalQuantity: number
  convertedQuantity: number
  badge: string
  onCloseProductListModal: () => void
}

const CardUnreceivedProduct: React.FC<CardUnreceivedProductProps> = ({
  currentIdModel,
  invoiceNumber,
  invoiceProductName,
  stockProductName,
  productCode,
  invoiceUnitType,
  originalQuantity,
  convertedQuantity,
  receivementId,
  newIdModel,
  badge,
  idArItem,
  onCloseProductListModal,
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const dispatch = useDispatch()
  const closeModalConfirmation = () => setShowConfirmModal(false)

  const onSuccessAssociateProduct = () => toast.success('Produto associado com sucesso')

  const checkProductExists = () => {
    if (!newIdModel) {
      toast.error('Produto Kdabra não cadastrado!')
      return
    }

    setShowConfirmModal(true)
  }

  const onSubmitAssociateProduct = () => {
    closeModalConfirmation()
    onCloseProductListModal()

    dispatch(actions.associateProductsReceivementThirdConference({
      badge,
      receivementId,
      idArItem,
      currentIdModel,
      newIdModel,
      onSuccess: onSuccessAssociateProduct,
    }))
  }

  return (
    <S.Container data-testid='card-unreceived-product-test-id'>
      <S.Row>
        <S.Column>
          <Typography sx={{ fontWeight: 700 }}>Produto nota fiscal</Typography>
        </S.Column>
        <S.Column backgroundColor={theme.colors.gray4} pl='.4rem'>
          <Typography sx={{ fontWeight: 700 }}>Produto Kdabra</Typography>
        </S.Column>
      </S.Row>
      <S.Row>
        <S.Column minWidth='25%'>
          <Typography variant='caption' color='ActiveBorder'>Número da nota</Typography>
          <Typography>{invoiceNumber}</Typography>
        </S.Column>
        <S.Column minWidth='25%'>
          <Typography variant='caption' color='ActiveBorder'>Unidade de medida</Typography>
          <Typography>{invoiceUnitType}</Typography>
        </S.Column>
        <S.Column backgroundColor={theme.colors.gray4} pl='.4rem'>
          <Typography variant='caption' color='ActiveBorder'>id modelo</Typography>
          <Typography>{newIdModel || '[NÃO CADASTRADO]'}</Typography>
        </S.Column>
      </S.Row>
      <S.Row>
        <S.Column minWidth='25%'>
          <Typography variant='caption' color='ActiveBorder'>Quantidade original</Typography>
          <Typography>{originalQuantity}</Typography>
        </S.Column>
        <S.Column minWidth='25%'>
          <Typography variant='caption' color='ActiveBorder'>Quantidade convertida</Typography>
          <Typography>{convertedQuantity}</Typography>
        </S.Column>
        <S.Column backgroundColor={theme.colors.gray4} pl='.4rem'>
          <Typography variant='caption' color='ActiveBorder'>Código do produto</Typography>
          <Typography>{productCode || '[NÃO CADASTRADO]'}</Typography>
        </S.Column>
      </S.Row>
      <S.Row>
        <S.Column>
          <Typography variant='caption' color='ActiveBorder'>Nome do produto</Typography>
          <Typography>{invoiceProductName}</Typography>
        </S.Column>
        <S.Column backgroundColor={theme.colors.gray4} pl='.4rem'>
          <Typography variant='caption' color='ActiveBorder'>Nome do produto</Typography>
          <Typography>{stockProductName}</Typography>
        </S.Column>
      </S.Row>
      <S.CustomButton
        title='Associar a esse produto'
        bgColor='darkBlue'
        hoverColor='darkBlueHover'
        letterColor='white'
        data-testid='associate-product-button-test-id'
        onClick={checkProductExists}
      />
      <ConfirmOrRejectModal
        show={showConfirmModal}
        title='Confirmação de associação de produto'
        customizableDescription={(
          <S.ContainerDescription>
            <p>
              Deseja associar o produto <strong>{capitalizeString(invoiceProductName)}</strong>
              <Typography variant='caption' color='ActiveBorder'>(produto nota fiscal)</Typography> ao produto <strong>{capitalizeString(stockProductName)}</strong>
              <Typography variant='caption' color='ActiveBorder'>(produto Kdabra)</Typography> ?
            </p>
          </S.ContainerDescription>
        )}
        onConfirm={onSubmitAssociateProduct}
        onReject={closeModalConfirmation}
        onClose={closeModalConfirmation}
        dataTestId='confirm-association-product-test-id'
      />
    </S.Container>
  )
}

export default CardUnreceivedProduct
